<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <label for="dateMonthID-field" class="form-label">Date</label>
  <select class="form-select" name="dateMonthID-field" id="dateMonthID-field" formControlName="dateMonthID" (change)="selectOnChange($event)">
    <option selected></option>
    @for (object of getDropdownDataObjectArray(); track object.id) {
      <option [ngValue]="object.id">{{object.description}}</option>    
    }
  </select>
</form>
